import React from "react";
import { RouteComponentProps } from "@reach/router";

const Dashboard: React.FC<RouteComponentProps> = () => {
  return <div className="bpm-copytiger">Coming soon...</div>;
};

export default Dashboard;
